import "./Img2Img.css";
import React, { Component } from "react";
import ImageLoader from "./common/ImageLoader";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { ImgTutorial } from "./Tutorials";
import { FaQuestionCircle } from "react-icons/fa";

class Img2Img extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.cropperRef = React.createRef();
    // useRef<HTMLImageElement>(null);
  }

  state = {
    cropURL: "",
    openModal: false,
    initImageURL: "",
    showHelp: false,
  };

  uploadFileButton = () => {
    if (this.props.handleUploadInitImage !== null) {
      this.myRef.current.click();
    }
  };

  handleUploadFileEvent = (e) => {
    const file = e.target.files[0];
    const url = URL.createObjectURL(file);
    this.setState({
      openModal: true,
      initImageURL: url,
    });
    e.target.value = null;
  };

  handleCropImage = async () => {
    const imageElement = this.cropperRef.current;
    const cropper = imageElement.cropper;
    const url = cropper
      .getCroppedCanvas({
        minWidth: 512,
        minHeight: 512,
        maxWidth: 512,
        maxHeight: 512,
      })
      .toDataURL();
    const blob = await (await fetch(url, { cache: "no-cache" })).blob();
    const file = new File([blob], "init_image.png", {
      type: "image/png",
      lastModified: new Date(),
    });
    this.setState({ openModal: false });
    this.props.handleUploadInitImage(file, url);
  };

  render() {
    return (
      <>
        {!this.props.isViewer && (
          <div
            style={{
              color: "white",
              textAlign: "center",
              fontSize: "10pt",
              margin: "5px",
            }}
          >
            {"Image to Image "}
            <FaQuestionCircle
              size={15}
              onClick={() => this.setState({ showHelp: true })}
              style={{ verticalAlign: "middle", cursor: "pointer" }}
            />
          </div>
        )}
        {this.state.showHelp && (
          <ImgTutorial
            close={() => {
              this.setState({ showHelp: false });
            }}
          />
        )}
        <div className="image-image-container">
          <div className="primary-image">
            {this.props.loading ? <ImageLoader /> : null}

            <img
              src={this.props.latestImageURL}
              alt="GeneratedImage"
              className="generator-image-prim"
            />
          </div>
          <div className="secundary-image">
            <img
              src={
                this.props.initImageURL === "./images/image_placeholder.png"
                  ? "./images/blanc.png"
                  : this.props.initImageURL
              }
              alt="GeneratedImage"
              className="generator-image-sec"
              style={{ cursor: "pointer" }}
              onClick={this.uploadFileButton}
            />
            {this.props.handleUploadInitImage !== null && (
              <div
                style={{
                  fontSize: "10px",
                  textAlign: "center",
                  cursor: "pointer",
                  color: "white",
                }}
                onClick={this.uploadFileButton}
              >
                Upload image
              </div>
            )}
          </div>
          <input
            type="file"
            id="file"
            ref={this.myRef}
            onChange={this.handleUploadFileEvent}
            accept=".jpg, .png"
          />
        </div>

        <div
          className="image-modal"
          style={{ display: this.state.openModal ? "block" : "none" }}
        >
          <div style={{ display: "block" }}>
            <div>
              <Cropper
                style={{ height: "512px", width: "60%", margin: "auto" }}
                initialAspectRatio={1}
                aspectRatio={1}
                preview=".img-preview"
                src={this.state.initImageURL}
                ref={this.cropperRef}
                viewMode={1}
                guides={true}
                minCropBoxHeight={512}
                minCropBoxWidth={512}
                cropBoxResizable={true}
                background={false}
                responsive={true}
                dragMode="move"
                checkOrientation={false}
                crop={this.onCrop}
              />
            </div>
            <button className="button-crop" onClick={this.handleCropImage}>
              Crop Image
            </button>
            <button
              className="button-cancel"
              onClick={() =>
                this.setState({ openModal: false, initImageURL: "" })
              }
              style={{ diplsay: "block" }}
            >
              Close
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default Img2Img;
